/**
 * Map each row's real (global) `seqId` to a per-client display number starting
 * at 1, ordered by creation (ascending numeric seqId).
 *
 * The database `seq_id` is a single global sequence shared across every tenant,
 * so a client's own rows can start at an arbitrary high number. A client only
 * ever sees its own company-scoped list, so numbering that list yields a stable
 * 1..N "from the client's perspective" sequence. The real `seqId` stays the
 * operational key (e.g. the recipient status toggle); this mapping is display
 * only.
 */
export function perClientSeqNo(seqIds: readonly string[]): Map<string, number> {
  const unique = Array.from(new Set(seqIds));
  unique.sort((a, b) => {
    const d = BigInt(a) - BigInt(b);
    return d < 0n ? -1 : d > 0n ? 1 : 0;
  });
  return new Map(unique.map((id, index) => [id, index + 1]));
}
